import script from "./FluidBoxWifiSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./FluidBoxWifiSetup.vue?vue&type=script&setup=true&lang=js"

import "./FluidBoxWifiSetup.vue?vue&type=style&index=0&id=ddd9a668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddd9a668"]])

export default __exports__